import React from 'react'
import {BsLinkedin} from 'react-icons/bs'
import {FaGithub} from 'react-icons/fa'
// import {FiDribbble} from 'react-icons/fi'

export default function HeaderSocials() {
  return (
    <div className="header__socials">
        <a href="https://www.linkedin.com/in/trevor-moir-7690529a/" target="_blank" rel="noopener noreferrer"><BsLinkedin /></a>
        <a href="https://github.com/trevormoir" target="_blank" rel="noopener noreferrer"><FaGithub /></a>
        {/* <a href="https://dribble.com" target="_blank" rel="noopener noreferrer"><FiDribbble /></a> */}
    </div>
  )
}
